'use strict';

import $ from 'jquery';
require('jquery.idle');
import cookies from 'js-cookie';
import config from '../../js/config';
import IdleActivityModal from './IdleActivityModal';
import cacheCookieHelper from '../../components/CacheCookieHelper/CacheCookieHelper';

export default class IdleActivityWatcher {
  static initialize() {
    let isUserActive = true;

    $(document).idle({
      onIdle: () => {
        let arrowFed = cookies.get(config.cookies.arrowFed);
        isUserActive = false;
        if (arrowFed) {
          IdleActivityModal.getInstance().open();
          setTimeout(() => {
            if (!isUserActive) {
              cookies.set(config.cookies.arrowFed, '', '');
              if (cacheCookieHelper) {
                cacheCookieHelper.setCacheCookie();
              }
              IdleActivityModal.getInstance().close();
            }
          },
          60000);
        }
      },
      onActive: () => {
        isUserActive = true;
      },
      idle: config.cookies.arrowfedExpiration
    });
  }
}

export function create() {
  IdleActivityWatcher.initialize();
}



// WEBPACK FOOTER //
// ./assets/components/IdleActivityWatcher/IdleActivityWatcher.js